module.exports = __webpack_public_path__ + "img/235.57c58c78.jpg";